import { createGlobalStyle } from 'styled-components';
export const GlobalStyle = createGlobalStyle `
  html.smaller-font-size {
    font-size: ${({ fontSize }) => fontSize};
  }
`;
